export default "__VITE_ASSET__BT4YSRks__"